'use client';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  my?: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;

  ${({ my }) =>
    my &&
    css`
      margin: ${my}px 0;
    `}

  p {
    margin-bottom: 0;
  }
`;

export const Text = styled.p<{
  fontSize?: number;
  paddingTop?: number;
  isBold?: boolean;
}>`
  font-size: ${({ fontSize = 14 }) => fontSize + 'px'};
  padding-top: ${({ paddingTop = 0 }) => paddingTop + 'px'};
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  text-align: center;
`;

export const BoldText = styled.span`
  font-weight: bold;
  padding: 0 3px;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 35px;

  & > p {
    margin-left: 5px;
  }
`;
